import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';
import { NotificationService } from "src/app/core/services/notification.service";
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { HelperService } from 'src/app/core/helper/helper.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { QuotingToolService } from '../quoting-tool.service';

@Component({
  selector: 'app-quote-my-project',
  templateUrl: './quote-my-project.component.html'
})
export class QuoteMyProjectComponent implements OnInit {
  getImagePath: any = environment.image_path;
  access_token!: any;
  userDetails: any = [];

  //create project
  createProjectFormSubmitted = false;
  createProjectForm!:FormGroup;

  constructor(private quotingService: QuotingToolService,private modalService: NgbModal,private router: Router,private helper: HelperService, private notificationService: NotificationService, private authService: AuthenticationService, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
      localStorage.removeItem('gerberFilePath');
      localStorage.removeItem('isStepComplited');
      localStorage.removeItem('gerberFile');
      localStorage.removeItem('projectType');
      localStorage.removeItem('upload_gerber');
      localStorage.removeItem('currentStepIndex');
      localStorage.removeItem('projectID');
      localStorage.removeItem('ID');
      localStorage.removeItem('projectType');
      localStorage.removeItem('prId');
    this.access_token = localStorage.getItem('customer_access_token')
    if (this.access_token) {
      this.GetUserData();
    }
    
  this.createProjectForm = new FormGroup({
    vProjectName: new FormControl("", [Validators.required,Validators.maxLength(100),Validators.pattern('^[A-Za-z0-9][A-Za-z0-9 ]*$')])
  });
  }
  
  ngOnDestroy(){
    this.modalService.dismissAll();
  }

  OpenCreateProjectModal(ModalName:any){
    this.createProjectForm.reset();

    this.modalService.open(ModalName, { centered: true, windowClass: 'edit-custom-modal', size: 'md' });
  }

  CreateProject() {
    this.createProjectFormSubmitted = true;

    // Check if the form is invalid
    if (this.createProjectForm.invalid) {
      this.createProjectForm.markAllAsTouched();
      return;
    }

    const reqJSON = {
      vProjectName: this.createProjectForm.value.vProjectName,
      vDescription: "dummy description",
      vProjectType: 2
    };
    // API Call Goes Here
    this.quotingService.CreateProject(reqJSON).subscribe((resJSON: any) => {
      if (resJSON.code == 200) {
        const projectID = resJSON.data.iProjectID;
        const projectType = resJSON.data.vProjectType;
        const uniqueID = resJSON.data._id;
        // Storing project ID and type in local storage
        localStorage.setItem("projectID", projectID);
        localStorage.setItem("projectType", projectType);
        localStorage.setItem("ID", uniqueID);
        this.RouteToEQuote();
        this.modalService.dismissAll();
        this.notificationService.showSuccess(`${resJSON.message}`, "");
      } else {
        this.notificationService.showError(`${resJSON.message}`, "");
      }
    });
  }
  
  routeTo(type: string) {
    this.router.navigate([`/${type}/create-project`]);
  }

  RouteToEQuote(){
    this.router.navigate(['/e-quotation']);
  }

  getRoute() {
    const accessToken = localStorage.getItem('customer_access_token');
    if(accessToken){
      this.router.navigate(['/customer/quotation-proposal'])
    } else {
      this.router.navigate([''])
    }
  }

  GetUserData() {
    this.authService.GetProfileData().subscribe((resJSON: any) => {
      if (resJSON.code == 200) {
        this.userDetails = resJSON.data;
      } else {
        this.notificationService.showError(`${resJSON.message}`, '');
      }
    });
  }

  isStepperFormsRoute(): boolean {
    const accessToken = localStorage.getItem('customer_access_token');
    return this.router.url.includes('/m-quotation') && accessToken !== null;
  }

  HandleLogout() {
    this.helper.Logout();
  }

  hasError(form: FormGroup, controlName: string, errorName: string): boolean {
    const control = form.get(controlName);
    return !!control?.hasError(errorName) && (!!control?.touched);
  }
}
